import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchLoginMethods } from '../../api/profileExtras';
import { useAuth } from '../../contexts/AuthContext';
import { isTelegramWebAppEnvironment } from '../../utils/telegramEnvironment';
import '../ProfilePhonesModal/ProfilePhonesModal.css';

const PROVIDER_LABELS = {
  telegram: 'Telegram',
  vk: 'VK ID',
};

export default function ProfileLoginMethodsModal({ token, onClose }) {
  const navigate = useNavigate();
  const { linkTelegramFromMiniapp } = useAuth();
  const [loading, setLoading] = useState(true);
  const [methods, setMethods] = useState([]);
  const [canAddTelegram, setCanAddTelegram] = useState(false);
  const [canAddVk, setCanAddVk] = useState(false);
  const [error, setError] = useState(null);
  const [linkBusy, setLinkBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await fetchLoginMethods(token);
        if (!cancelled) {
          setMethods(data.methods || []);
          setCanAddTelegram(Boolean(data.can_add_telegram));
          setCanAddVk(Boolean(data.can_add_vk));
        }
      } catch {
        if (!cancelled) setError('Не удалось загрузить способы входа');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  const openLinkPage = (provider) => {
    onClose();
    navigate(`/main/profile/link-account?provider=${provider}`);
  };

  const handleLinkTelegramInMiniapp = async () => {
    setLinkBusy(true);
    setError(null);
    try {
      const ok = await linkTelegramFromMiniapp();
      if (ok) onClose();
      else setError('Не удалось привязать Telegram');
    } catch (e) {
      setError(e.message || 'Не удалось привязать Telegram');
    } finally {
      setLinkBusy(false);
    }
  };

  return (
    <div className="profile-phones-modal__backdrop" role="presentation" onClick={onClose}>
      <div
        className="profile-phones-modal__dialog"
        role="dialog"
        aria-labelledby="profile-login-methods-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="profile-login-methods-title" className="profile-phones-modal__title">
          Способы входа
        </h2>
        {loading ? <p className="profile-phones-modal__muted">Загрузка…</p> : null}
        {error ? <p className="profile-phones-modal__err">{error}</p> : null}
        <ul className="profile-phones-modal__list">
          {methods.map((m) => (
            <li key={`${m.provider}-${m.provider_user_id}`} className="profile-phones-modal__item">
              <div className="profile-phones-modal__row profile-phones-modal__row--active">
                <span className="profile-phones-modal__number">
                  {PROVIDER_LABELS[m.provider] || m.provider}
                </span>
                <span className="profile-phones-modal__platforms">ID: {m.provider_user_id}</span>
              </div>
            </li>
          ))}
        </ul>
        {!loading && methods.length === 0 ? (
          <p className="profile-phones-modal__muted">Нет привязанных способов</p>
        ) : null}
        {canAddVk ? (
          <button
            type="button"
            className="profile-phones-modal__close"
            style={{ marginBottom: 8 }}
            onClick={() => openLinkPage('vk')}
          >
            Добавить VK ID
          </button>
        ) : null}
        {canAddTelegram ? (
          isTelegramWebAppEnvironment() ? (
            <button
              type="button"
              className="profile-phones-modal__close"
              style={{ marginBottom: 8 }}
              disabled={linkBusy}
              onClick={() => void handleLinkTelegramInMiniapp()}
            >
              {linkBusy ? 'Привязка…' : 'Привязать Telegram'}
            </button>
          ) : (
            <button
              type="button"
              className="profile-phones-modal__close"
              style={{ marginBottom: 8 }}
              onClick={() => openLinkPage('telegram')}
            >
              Добавить Telegram
            </button>
          )
        ) : null}
        <button type="button" className="profile-phones-modal__close" onClick={onClose}>
          Закрыть
        </button>
      </div>
    </div>
  );
}
